import { View, Text } from '@react-pdf/renderer';
import { shared } from '../styles';
import { ClinicalInstructionsDocument } from '../ClinicalInstructionsDocument';
import type { ClinicalDocVariant } from '../ClinicalInstructionsDocument';
import type { RDIFormData, SectionToggles } from '../../clinical/types';

interface RdiDocumentProps {
    data: RDIFormData;
    hasOrthopulse: boolean;
    toggles: SectionToggles;
}

const variant: ClinicalDocVariant = {
    title: 'Refinement Information:',
    notesKey: 'rdi-notes',
    extraDisclaimer: (
        <View style={shared.section}>
            <Text style={shared.warningText}>
                Gray attachments (in page 1) are pre-existing. Check each gray attachment to verify
                they are intact and replace as needed. Fill new attachments (in blue) if required.
                If there are integrated hooks, an attachment is needed on that tooth.
            </Text>
        </View>
    ),
    alignerScheduleTitle: 'Aligner wear schedule:',
    helpLinkAdditionalText:
        'For additional instructions (IPR, Bonding attachments etc), visit here:'
};

function RdiDocument({ data, hasOrthopulse, toggles }: RdiDocumentProps) {
    return (
        <ClinicalInstructionsDocument
            data={{ ...data, nextAppointmentValue: data.nextAppointment }}
            hasOrthopulse={hasOrthopulse}
            toggles={toggles}
            variant={variant}
        />
    );
}

export { RdiDocument };
